import MNotification from './MNotification.vue';

MNotification.install = (app) => {
  app.component('MNotification', MNotification);
};

export { MNotification };
